import * as asyncUtils from 'ui-permit/shared-components/utils/async';
import * as ACTIONS from '../constants/actions';

const clearLotteries = asyncUtils.makeAsyncResetReducer(ACTIONS.RESET_LOTTERIES);

const getLottery = asyncUtils.makeAsyncReducer(ACTIONS.GET_LOTTERY);

const getLotteryApplication = asyncUtils.makeAsyncReducer(
    ACTIONS.GET_LOTTERY_APPLICATION
);

const createLotteryApplication = asyncUtils.makeAsyncReducer(
    ACTIONS.CREATE_LOTTERY_APPLICATION
);

const updateLotteryApplication = asyncUtils.makeAsyncReducer(
    ACTIONS.UPDATE_LOTTERY_APPLICATION
);

export const lottery = asyncUtils.mergeReducers(
    asyncUtils.asyncDefaults({}),
    ACTIONS.PREFIX,
    getLottery,
    clearLotteries
);

export const lotteryApplication = asyncUtils.mergeReducers(
    asyncUtils.asyncDefaults({}),
    ACTIONS.PREFIX,
    getLotteryApplication,
    createLotteryApplication,
    updateLotteryApplication
);

export const selectors = {
    getLottery: (state) => {
        const lotteryData = state.queuingLottery?.lottery?.data;
        if(Array.isArray(lotteryData)) {
            return lotteryData?.[0] || {};
        }
        return lotteryData || {};
    },
    getLotteryApplication: (state) => {
        return state.queuingLottery?.lotteryApplication?.data;
    },
    isBooking: (state) => {
        return state.queuingLottery?.lotteryApplication?.loading;
    },
    getApplicationError: (state) => {
        return state.queuingLottery?.lotteryApplication?.error;
    },
    getErrors: (state) => {
        const lotteryError = state.queuingLottery?.lottery?.error;
        const applicationError = state.queuingLottery?.lotteryApplication?.error;
        return [lotteryError, applicationError];
    },
};
